import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DrillDetailLink from './drillDetailLink.component';
import CustomNumeral from '../../shared/customNumeral.component';
import {
  TOTAL_ROW,
  rowTypes,
  funcCurrencyFieldDescription,
  taxCurrencyFieldDescription,
} from './constants';

import { taxExpenseRowsSelector, detailAggregationSelector, countryTaxTypeToFilterSelector } from './store/selectors';

class DrillDetailColumnsLink extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    index: PropTypes.number.isRequired,
    reportLineType: PropTypes.string.isRequired,
    columnTitle: PropTypes.string.isRequired,

    rows: PropTypes.arrayOf(PropTypes.shape({
      reportLineType: PropTypes.string,
      description: PropTypes.string,
      columns: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      })),
    })),
    useHistorical: PropTypes.bool,
    detailAggregationType: PropTypes.string.isRequired,
    countryTaxType: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const { rows, index } = props;
    const titleRow = rows.find(row => row.rowType === rowTypes.COLUMN_HEADER);
    const funcCurrencyRow = rows.find(row =>
      row.rowType === rowTypes.TEXT && row.description === funcCurrencyFieldDescription
    );
    const taxCurrencyRow = rows.find(row =>
      row.rowType === rowTypes.TEXT && row.description === taxCurrencyFieldDescription
    );

    this.groupItem = titleRow.columns[index].value;
    this.funcCurrency = funcCurrencyRow.columns[index].value;
    this.taxCurrency = taxCurrencyRow ? taxCurrencyRow.columns[index].value : this.funcCurrency;
  }

  render() {
    const { reportLineType, columnTitle, value, useHistorical } = this.props;

    return (
      this.groupItem === TOTAL_ROW
        ? <CustomNumeral>{value}</CustomNumeral>
        : (
          <DrillDetailLink
            reportLineType={reportLineType}
            columnTitle={columnTitle}
            groupItem={this.groupItem}
            funcCurrency={this.funcCurrency}
            taxCurrency={this.taxCurrency}
            useHistorical={useHistorical}
            detailAggregationType={this.props.detailAggregationType}
            countryTaxType={this.props.countryTaxType}
          >
            <CustomNumeral>{value}</CustomNumeral>
          </DrillDetailLink>
        )
    );
  }
}

function mapStateToProps(state) {
  return {
    rows: taxExpenseRowsSelector(state),
    detailAggregationType: detailAggregationSelector(state),
    countryTaxType: countryTaxTypeToFilterSelector(state),
  };
}

export default connect(mapStateToProps)(DrillDetailColumnsLink);
